import {
  coreExtensionData,
  createExtension,
  createExtensionInput,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SidebarPage } from '@backstage/core-components';
import { Box, makeStyles } from '@material-ui/core';
import { StatusHeader } from '../components/Root/StatusHeader';

const useStyles = makeStyles({
  main: {
    '& main': {
      height: 'auto !important',
    },
  },
});

// Same id as upstream's AppLayout, so this replaces it. Identical, plus the
// wrapper reserving StatusHeader's 40px -- it is position: fixed and would
// otherwise cover the top of every page.
const layoutExtension = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    nav: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  factory: ({ inputs }) => {
    const Layout = () => {
      const classes = useStyles();
      return (
        <SidebarPage>
          {inputs.nav.get(coreExtensionData.reactElement)}
          <Box
            className={classes.main}
            sx={{ width: '100%', paddingTop: '40px' }}
          >
            <StatusHeader />
            {inputs.content.get(coreExtensionData.reactElement)}
          </Box>
        </SidebarPage>
      );
    };
    return [coreExtensionData.reactElement(<Layout />)];
  },
});

export const layoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [layoutExtension],
});
